import { IUser } from "../../types/userTypes";
import { AuthorizedUserActionTypes } from "../types/authorized-user";
import { ReturnActionType } from "../types/return-type";

export const setAuthorizedUser = (payload: IUser | null): ReturnActionType => ({
  type: AuthorizedUserActionTypes.SET_AUTHORIZED_USER,
  payload,
});
